import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AdminLayout from './Components/Layouts/AdminLayout';
import FrontLayout from './Components/Layouts/FrontLayout';
import BazaarLayout from './Components/Layouts/BazaarLayout';
import AuthLayout from './Components/Layouts/AuthLayout';
import Dashboard from './Components/Pages/Admin/Dashboard';
import Users from './Components/Pages/Admin/Users';
import Kycs from './Components/Pages/Admin/Kycs';
import AddMoney from './Components/Pages/Admin/AddMoney';
import CashVoucher from './Components/Pages/Admin/CashVoucher';
import Recharge from './Components/Pages/Admin/Recharge';
import IndianRecharge from './Components/Pages/Admin/IndianRecharge';
import IndoNepalMoneyTransfer from './Components/Pages/Admin/IndoNepalMoneyTransfer';
import IndoNepalMoneyTransfer1 from './Components/Pages/Admin/IndoNepalMoneyTransfer1';
import ImeMoneyTransfer from './Components/Pages/Admin/ImeMoneyTransfer';
import ImeKycMoneyTransfer from './Components/Pages/Admin/ImeKycMoneyTransfer';
import CspIndoNepal from './Components/Pages/Admin/CspIndoNepal';
import CspIme from './Components/Pages/Admin/CspIme';
import RechargeReport from './Components/Pages/Admin/RechargeReport';
import RemitanceReport from './Components/Pages/Admin/RemitanceReport';
import ImeReport from './Components/Pages/Admin/ImeReport';
import RemittanceWalletHistory from './Components/Pages/Admin/RemittanceWalletHistory';
import RechargeWalletHistory from './Components/Pages/Admin/RechargeWalletHistory';
import Settings from './Components/Pages/Admin/Settings';
import UserKyc from './Components/Pages/Admin/UserKyc';
import AppSettings from './Components/Pages/Admin/AppSettings';
import ServiceCategories from './Components/Pages/Admin/ServiceCategories';
import ServiceProviders from './Components/Pages/Admin/ServiceProviders';
import Notice from './Components/Pages/Admin/Notice';
import MoneyTransfer from './Components/Pages/Admin/MoneyTransfer';
import CheckIndoNepalTransaction from './Components/Pages/Admin/CheckIndoNepalTransaction';
import CheckPayuTransaction from './Components/Pages/Admin/CheckPayuTransaction';
import RechargeSuccess from './Components/Pages/Admin/RechargeSuccess';
import RechargeFail from './Components/Pages/Admin/RechargeFail';
import VerifyTransaction from './Components/Pages/Admin/VerifyTransaction';
import Complaint from './Components/Pages/Admin/Complaint';
import PendingRequest from './Components/Pages/Admin/PendingRequest';
import ProductCategory from './Components/Pages/Admin/ProductCategory';
import ProductSubCategory from './Components/Pages/Admin/ProductSubCategory';
import Products from './Components/Pages/Admin/Products';
import Orders from './Components/Pages/Admin/Orders';
import LotteryCoupons from './Components/Pages/Admin/LotteryCoupons';
import LotteryResults from './Components/Pages/Admin/LotteryResults';
import Login from './Components/Pages/Login';
import Register from './Components/Pages/Register';
import ForgotPassword from './Components/Pages/ForgotPassword';
import Home from './Components/Pages/Home';
import About from './Components/Pages/About';
import Team from './Components/Pages/Team';
import Services from './Components/Pages/Services';
import Contact from './Components/Pages/Contact';
import BuyCoupon from './Components/Pages/BuyCoupon';
import LotteryResult from './Components/Pages/LotteryResult';
import CouponSuccess from './Components/Pages/CouponSuccess';
import CouponFail from './Components/Pages/CouponFail';
import TermAndConditions from './Components/Pages/TermAndConditions';
import PrivacyPolicy from './Components/Pages/PrivacyPolicy';
import RefundPolicy from './Components/Pages/RefundPolicy';
import ReturnPolicy from './Components/Pages/ReturnPolicy';
import ShippingPolicy from './Components/Pages/ShippingPolicy';

import BazaarHome from './Components/Pages/BazaarHome';
import BazaarAbout from './Components/Pages/BazaarAbout';
import BazaarShop from './Components/Pages/BazaarShop';
import BazaarProduct from './Components/Pages/BazaarProduct';
import BazaarCart from './Components/Pages/BazaarCart';
import BazaarCheckout from './Components/Pages/BazaarCheckout';
import BazaarOrderSuccess from './Components/Pages/BazaarOrderSuccess';
import BazaarOrderFail from './Components/Pages/BazaarOrderFail';

import './App.css';

function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* <Route path="/buyCoupon" element={<BuyCoupon />} />
          <Route path="/lotteryResult/:email" element={<LotteryResult />} /> */}
          {/* Auth Routes */}
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
          </Route>

          {/* Front-End Routes */}
          <Route element={<FrontLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/team" element={<Team />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            {/* <Route path="/couponSuccess" element={<CouponSuccess />} />
            <Route path="/couponFail" element={<CouponFail />} /> */}
            <Route path="/termAndConditions" element={<TermAndConditions />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/refundPolicy" element={<RefundPolicy />} />
            <Route path="/returnPolicy" element={<ReturnPolicy />} />
            <Route path="/shippingPolicy" element={<ShippingPolicy />} />
          </Route>

          {/* Pargati-Bazaar Routes */}
          <Route element={<BazaarLayout />}>
            <Route path="/bazaar" element={<BazaarHome />} />
            <Route path="/bazaar/about" element={<BazaarAbout />} />
            <Route path="/bazaar/shop" element={<BazaarShop />} />
            <Route path="/bazaar/product/:id" element={<BazaarProduct />} />
            <Route path="/bazaar/cart" element={<BazaarCart />} />
            <Route path="/bazaar/checkout" element={<BazaarCheckout />} />
            <Route path="/bazaar/orderSuccess" element={<BazaarOrderSuccess />} />
            <Route path="/bazaar/orderFail" element={<BazaarOrderFail />} />
          </Route>

          {/* Admin Routes */}
          <Route element={<AdminLayout />}>
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/users" element={<Users />} />
            <Route path="/admin/kycs" element={<Kycs />} />
            <Route path="/admin/addMoney" element={<AddMoney />} />
            <Route path="/admin/cashVoucher" element={<CashVoucher />} />
            <Route path="/admin/recharge" element={<Recharge />} />
            <Route path="/admin/indianRecharge" element={<IndianRecharge />} />
            <Route path="/admin/indoNepalMoneyTransfer" element={<IndoNepalMoneyTransfer1 />} />
            <Route path="/admin/indoNepalMoneyTransfer1" element={<IndoNepalMoneyTransfer />} />
            <Route path="/admin/imeMoneyTransfer" element={<ImeMoneyTransfer />} />
            <Route path="/admin/imeKycMoneyTransfer" element={<ImeKycMoneyTransfer />} />
            <Route path="/admin/cspIndoNepal" element={<CspIndoNepal />} />
            <Route path="/admin/cspIme" element={<CspIme />} />
            <Route path="/admin/rechargeReport" element={<RechargeReport />} />
            <Route path="/admin/remitanceReport" element={<RemitanceReport />} />
            <Route path="/admin/imeReport" element={<ImeReport />} />
            <Route path="/admin/remittanceWalletHistory" element={<RemittanceWalletHistory />} />
            <Route path="/admin/rechargeWalletHistory" element={<RechargeWalletHistory />} />
            <Route path="/admin/settings" element={<Settings />} />
            <Route path="/admin/kycVerification" element={<UserKyc />} />
            <Route path="/admin/appSettings" element={<AppSettings />} />
            <Route path="/admin/serviceCategories" element={<ServiceCategories />} />
            <Route path="/admin/serviceProviders" element={<ServiceProviders />} />
            <Route path="/admin/notice" element={<Notice />} />
            <Route path="/admin/moneyTransfer" element={<MoneyTransfer />} />
            <Route path="/admin/checkIndoNepalTransaction" element={<CheckIndoNepalTransaction />} />
            <Route path="/admin/checkPayuTransaction" element={<CheckPayuTransaction />} />
            <Route path="/admin/rechargeSuccess" element={<RechargeSuccess />} />
            <Route path="/admin/rechargeFail" element={<RechargeFail />} />
            <Route path="/admin/verifyTransaction" element={<VerifyTransaction />} />
            <Route path="/admin/complaint" element={<Complaint />} />
            <Route path="/admin/pendingRequest" element={<PendingRequest />} />
            <Route path="/admin/productCategory" element={<ProductCategory />} />
            <Route path="/admin/productSubCategory" element={<ProductSubCategory />} />
            <Route path="/admin/products" element={<Products />} />
            <Route path="/admin/orders" element={<Orders />} />
            <Route path="/admin/lotteryCoupons" element={<LotteryCoupons />} />
            <Route path="/admin/lotteryResults" element={<LotteryResults />} />
          </Route>
        </Routes>
      </Router>
      <div className="loader-overlay">
        <div className="spinner"></div>
      </div>
    </>
  );
}

export default App;